export type ElderAdmissionStatus = "pending" | "approved" | "rejected" | string;

export interface ElderAdmissionFamilyMember {
  id?: number;
  name: string;
  relationship: number;
  relationship_name?: string;
  relationship_code?: string;
  mobile_number: string;
  address?: string;
  occupation?: string;
  income?: string | null;
  is_emergency_contact: boolean;
}

export interface ElderAdmissionFamilyMemberPayload {
  name: string;
  relationship: number;
  mobile_number: string;
  address?: string;
  occupation?: string;
  income?: string | null;
  is_emergency_contact: boolean;
}

export interface ElderAdmissionPayload {
  applicant_name: string;
  applicant_mobile: string;
  applicant_address: string;
  relationship_with_elder: number;
  elder_name: string;
  father_name?: string;
  age: number;
  district: number;
  city: number;
  area: number;
  current_living_situation?: string;
  physical_condition?: string;
  reason_for_admission: string;
  pension_details?: string;
  other_income?: string;
  emergency_contact_1: string;
  emergency_contact_2?: string | null;
  emergency_contact_3?: string | null;
  additional_notes?: string;
  family_members: ElderAdmissionFamilyMemberPayload[];
}

export interface ElderAdmissionRecord {
  id: number;
  applicant_name: string;
  applicant_mobile: string;
  applicant_address: string;
  relationship_with_elder: number;
  relationship_with_elder_name?: string;
  relationship_with_elder_code?: string;
  elder_name: string;
  father_name?: string;
  age: number;
  district: number;
  city: number;
  area: number;
  district_name?: string;
  city_name?: string;
  area_name?: string;
  current_living_situation?: string;
  physical_condition?: string;
  reason_for_admission?: string;
  pension_details?: string;
  other_income?: string;
  emergency_contact_1?: string;
  emergency_contact_2?: string | null;
  emergency_contact_3?: string | null;
  additional_notes?: string;
  status: ElderAdmissionStatus;
  family_members?: ElderAdmissionFamilyMember[];
  created_at?: string;
  updated_at?: string;
}

export type ElderAdmission = Pick<
  ElderAdmissionRecord,
  "id" | "applicant_name" | "elder_name" | "created_at"
>;

export function formatAdmissionNumber(
  record: Pick<ElderAdmissionRecord, "id" | "created_at">
): string {
  const year = record.created_at
    ? new Date(record.created_at).getFullYear()
    : new Date().getFullYear();
  return `ADM-${year}-${String(record.id).padStart(4, "0")}`;
}

export function normalizeAdmissionStatus(
  status: ElderAdmissionStatus
): "pending" | "approved" | "rejected" {
  const value = String(status).toLowerCase();
  if (value === "approved") {
    return "approved";
  }
  if (value === "rejected") {
    return "rejected";
  }
  return "pending";
}

export interface ElderAdmissionStats {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
}
